import { Component, OnInit, OnDestroy, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserRoleModel } from '../user-role.model';
import { CustomerDispatcher } from '../../../store/customer/customer-dispatcher';
import { OrchestrationService } from '../../services/orchestration-service/orchestration.service';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { SnackBarService } from '../../../common/services/snack-bar/snack-bar.service';
import { ApiResponseDispatcher } from '../../../store/api-response/api-response-dispatcher';
import { select } from '@angular-redux/store';
import { Observable, Subscription } from 'rxjs';
import { ApiResponseState } from '../../../store/api-response/api-response-state.model';
import { CommonDispatcher } from '../../../store/common/common-dispatcher';
import { UserRoleDispatcher } from '../../../store/user-role/user-role-dispatcher';
import { SideNavService } from '../../services/sidenav-service/sidenav.service';
import { RequestType, UserRoleObjects, UserTypes } from '../user-role.details';

import {
  Role,
  UserRoles,
} from '../../../store/user-role/user-role-state.model';
import { DialogBoxComponent } from '../../../common/components/dialog-box/dialog-box.component';
import { MatDialog } from '@angular/material';
import { Common } from '../../../store/common/common-state.model';
import { regex } from '../../../common/regex.constants';
import { ApiResponseActions } from '../../../store/api-response/api-response-actions';
import { NgIf, NgFor } from '@angular/common';
import { MatFormField, MatLabel, MatError } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-user-role-edit',
    templateUrl: './user-role-update.component.html',
    styleUrls: ['./user-role-update.component.scss'],
    imports: [NgIf, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MatRadioGroup, NgFor, MatRadioButton, MatCheckbox, MatIcon, TranslatePipe]
})
export class UserRoleUpdateFormComponent
  implements OnInit, OnDestroy, OnChanges {
  /**
   * @property Data binded to use in the component
   **/
  @Input() userRoles: UserRoles;
  /**
   * @property Data binded to use in the component
   **/
  @Input() roleList: Array<Role>;
  /**
 * @property Data binded to use in the component
 **/
  @Input() isAddUser: boolean;
  /**
   * @Property to hold the displayed form
   **/
  public showForm;
  /**
   *@var to store  input fields.
   **/
  public form_group: UntypedFormGroup;
  /**
   *@var to store the model
   **/
  public model: UserRoleModel;
  /**
   *@arg commonObservable to observe common for show result
   **/
  @select('common') readonly commonObservable: Observable<Common>;
  /**
   *@arg  observe api variable in redux
   **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;
  private commonSubscriper: Subscription;
  /**
   *@var title to store the translations for title on condition
   **/
  public title: string;
  /**
   *@var title to store the boolean value to enable delete user button
   **/
  public showDeleteBtn: boolean;
  /**
   *@var UserRoleObjects to hold user role selections
   **/
  public UserRoleObjects: any;
  /**
   *@var UserTypes to hold user type selections
   **/
  public UserTypes: any;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public fb: UntypedFormBuilder,
    public translate: TranslationService,
    private apiDispatcher: ApiResponseDispatcher,
    public dispatcher: CustomerDispatcher,
    public dialog: MatDialog,
    private snackBar: SnackBarService,
    public orch: OrchestrationService,
    public customerDispatcher: CustomerDispatcher,
    public commonDispatcher: CommonDispatcher,
    public userRoleDispatcher: UserRoleDispatcher,
    public sidenav: SideNavService
  ) { }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
    this.subscribeConfrimationResult();
    this.apiObservable.subscribe((api) => {
      if (
        ApiResponseActions.SET_USER_DELETE === api.apiAction &&
        !!api.userDelete['type']
      ) {
        if (api.userDelete['type'] === 'success') {
          this.apiDispatcher.setUserDelete({});
          this.sidenav.close();
          this.snackBar.showToast(this.translate.getCustomTranslation('user-roles.labels.delete-user-success')['value']);
        } else {
          this.snackBar.showToast(this.translate.getCustomTranslation('user-roles.labels.delete-user-failed')['value']);
        }
      }
    });
  }

  /**
   * @function setUserType to set the userType whenever there is change in the radio button selection
   */
  public setUserType(event) {
    this.UserTypes.forEach(type =>  {
      type.selected = (type.typeMapping === event.value) ? true : false;
    });
    this.form_group.controls.userType.setValue(event.value);
  }

  /**
   * @function searchUserRoleObjects to loop through UserRoleObjects array to find a value
   */
  searchUserRoleObjects(userRole): any {
    let tabIndex = -1;
    let roleIndex = -1;
    this.UserRoleObjects.forEach(
      (item, i) => {
      (item.roles || []).forEach(
        (role, j) => {
        if (userRole.roleName === role.roleMapping) {
          tabIndex = i;
          roleIndex = j;
        }
      }
    );
    }
  );
    return [tabIndex, roleIndex];
  }

  /**
   * @function setRoleCheckboxes to set role checkboxes by assigned user roles
   */
  setRoleCheckboxes(tabIndex, roleIndex) {
    if (this.UserRoleObjects[tabIndex].roles.every((role => role.selected === true))) {
      this.UserRoleObjects[tabIndex].selected = true;
      this.UserRoleObjects[tabIndex].isIndeterminate = false;
    } else {
      this.UserRoleObjects[tabIndex].selected = false;
      if (this.UserRoleObjects[tabIndex].roles.filter(role => role.selected).length > 0) {
        this.UserRoleObjects[tabIndex].isIndeterminate = true;
      } else {
        this.UserRoleObjects[tabIndex].isIndeterminate = false;
      }
    }
    this.updateFormGroupValue(tabIndex, roleIndex);
  }

  /**
   * @function setTabCheckboxes to set tab checkboxes by assigned user roles
   */
  setTabCheckboxes(tabIndex) {
    this.UserRoleObjects[tabIndex].isIndeterminate = false;
    if (this.UserRoleObjects[tabIndex].selected) {
      this.UserRoleObjects[tabIndex].roles.forEach(
        (role, index) => {
          role.selected = true;
          this.updateFormGroupValue(tabIndex, index);
        }
      );
    } else {
      this.UserRoleObjects[tabIndex].roles.forEach(
        (role, index) => {
          role.selected = false;
          this.updateFormGroupValue(tabIndex, index);
        }
      );
    }
  }

  /**
   * @function isServiceConnectRoleAssigned Method to check if a service connect role is already assigned
   * @param role the current user role group
  */
  isServiceConnectRoleAssigned(roleGroup) {
    let isServiceConnectRoleAssigned = false;
    if(roleGroup.tabName === 'Service Connect'){
      roleGroup.roles.forEach(role => {
        if(role.selected) {isServiceConnectRoleAssigned = !isServiceConnectRoleAssigned};
      })
    }
    return isServiceConnectRoleAssigned;
  }

  /**
   * @function updateUserRoles Method to update roles from inputs
   */
  updateUserRoles() {
    this.model.userRoles = {
      roles: this.userRoles.roles,
      user: {
        email: this.userRoles.email_address,
        type: this.userRoles.userType
      },
    };
    this.model.updateUserRoles(this.roleList || []);

    if (!this.isAddUser) {
      this.userRoles.roles.forEach(
        role => {
          const [tabIndex, roleIndex] = this.searchUserRoleObjects(role);
          if (tabIndex === -1 || roleIndex === -1) {
            return;
          }

          this.UserRoleObjects[tabIndex].roles[roleIndex].selected = true;
          this.setRoleCheckboxes(tabIndex, roleIndex);
        }
      );
    } else {
      this.resetUserRoleObjects();
    }

  }

  /**
   * @function updateFormValues Method to update form values from inputs
   */
  updateFormValues() {
    this.form_group.controls.userEmail.setValue(
      this.model.userRoles.user.email
    );
    this.form_group.controls.userType.setValue(
      this.userRoles.userType
    );
    for (const role of this.model.userRoles.roles) {
      (this.form_group.get('roles') as UntypedFormArray).push(
        this.fb.group({
          roleID: role.roleID,
          allowed: !!role.allowed,
          roleName: role.roleName,
        })
      );
    }
  }

  subscribeConfrimationResult() {
    this.commonSubscriper = this.commonObservable.subscribe((common) => {
      if (common.showResults === 'confirmed') {
        this.submitUserRoles();
      }
    });
  }

  /**
   * onKeyUp updates the form value
   **/
  public onKeyUp(): void {
    this.form_group.controls.userEmail.setValue(
      (this.form_group.controls.userEmail.value || '')
        .replace(/ /g, '')
        .trim()
    );
    this.form_group.controls.userEmail.updateValueAndValidity();
  }

  /**
   * @function showDialog Method to show dialog before updating the new roles to the user
   */
  public showDialog() {
    this.dialog.open(DialogBoxComponent, {
      data: {
        type: 'warn-role-change',
        message: this.isAddUser ? `${this.translate.getCustomTranslation('user-roles.labels.want-to-add')['value']} '${this.form_group.controls.userEmail.value}'
        ${this.translate.getCustomTranslation('user-roles.labels.new-user')['value']}` : `${this.translate.getCustomTranslation('user-roles.labels.want-to-change')['value']}'${this.model.userRoles.user.email
        }' ${this.translate.getCustomTranslation('user-roles.labels.role-to')['value']} ${this.form_group.value.roles
          .filter((role) => !!role.allowed)
          .map((role) => role.roleName.replace(/_/g, ' '))
          .join(', ')}`,
      },
      width: '30em',
      height: 'auto',
    });
  }

  /**
   *@function someRoleSelected method to get if roles are selected
   */
  public someRoleSelected(): boolean {
    return this.form_group.value.roles.some((role) => !!role.allowed);
  }
  /**
   * @function someTypeSelected method to get if a user type is selected
   */
  public someTypeSelected(): boolean {
    let flag = false;
    UserTypes.forEach(type => {
      if (type.selected === true){
        flag = true;
      }
    });
    return flag;
  }

   /**
   * @get fieldsSelected method to disable/enable confirm button
   */
  public get fieldsSelected(): boolean{
    return this.isAddUser ? (this.someRoleSelected() && this.form_group.controls.userEmail.valid && this.someTypeSelected()) : this.someRoleSelected();
  }

  /**
   * @function ngOnDestroy Method to clean when component exit from view and make a clean room after a new visit
   */
  ngOnDestroy(): void {
    this.showForm = false;
    this.form_group.reset();
    this.model.clearRequestAttributes();
    if (this.commonSubscriper) {
      this.commonSubscriper.unsubscribe();
    }
    delete this.form_group;
    this.clear();
    this.showDeleteBtn = false;
  }
  /**
   * ngOnChanges ngOnChanges update user-roles and form
   **/
  ngOnChanges() {
    this.setDefaults();
    this.updateUserRoles();
    this.updateFormValues();
    this.showForm = true;
  }
  /**
   * setDefaults Default data that set for the form
   **/
  public setDefaults(): void {
    this.showForm = false;
    this.title = this.translate.getCustomTranslation(this.isAddUser ? 'user-roles.labels.add-user' : 'user-roles.labels.edit-user')['value'];
    this.model = new UserRoleModel();
    this.form_group = this.fb.group({
      userEmail: [{ value: false, disabled: !this.isAddUser }, [Validators.required, Validators.pattern(regex.emailPattern)]],
      userType: "",
      roles: this.fb.array([]),
    });
    this.showDeleteBtn = !this.isAddUser;

    this.UserRoleObjects = UserRoleObjects;
    this.UserTypes = UserTypes;
    this.initializeUserType();
  }

  /**
   * @function initializeUserType populates UserType with the user's values
   */
  public initializeUserType(){
    if (!this.isAddUser){
    this.UserTypes.forEach(type =>  {
      if(type.typeMapping === this.userRoles.userType){
        type.selected = true;
      }
    });
  } else {
      this.resetUserTypes();
    }
  }

  /**
   * @function onSelectTab sets all the user roles under a tab as selected or not upon click
   */
  public onSelectTab(tabIndex): void {
    this.UserRoleObjects[tabIndex].selected = !this.UserRoleObjects[tabIndex].selected;
    this.setTabCheckboxes(tabIndex);
  }
  /**
   * @function onSelectRole set a single role as selected or not upon click
   */
  public onSelectRole(tabIndex, roleIndex): void {
    this.UserRoleObjects[tabIndex].roles[roleIndex].selected = !this.UserRoleObjects[tabIndex].roles[roleIndex].selected;
    this.setRoleCheckboxes(tabIndex, roleIndex);
  }
  /**
   * @function onDropdownClick opens and closes the user role tabs upon arrow click
   */
  public onDropdownClick(tabIndex): void {
    this.UserRoleObjects[tabIndex].expanded = !this.UserRoleObjects[tabIndex].expanded;
  }

  /**
   * @function updateFormGroupValue updates the form_group based on UserRoleObjects
   * loops through this.form_group.value.roles, get role name and modify allowed = true
   */
  public updateFormGroupValue(tabIndex, roleIndex) {
    if (this.UserRoleObjects[tabIndex].roles[roleIndex].selected === true) {
      this.form_group.value.roles.forEach((role) => {
        if (this.UserRoleObjects[tabIndex].roles[roleIndex].roleMapping === role.roleName) { role.allowed = true; }
      });
    } else {
      this.form_group.value.roles.forEach((role) => {
        if (this.UserRoleObjects[tabIndex].roles[roleIndex].roleMapping === role.roleName) { role.allowed = false; }
      });
    }
  }
  /**
   * Get role Initiates submission calls for updating user roles.
   **/
  public submitUserRoles(): void {
    this.model.error = false;
    this.defaults();
    this.orch.submitUser(this.model.requestAttributes);
    setTimeout(() => {
      this.clear();
    }, 1000);
  }
  /**
   * defaults settings before api call
   **/
  public defaults(): void {
    if (!!this.model.userRoles.user.email) {
      this.form_group.controls.userEmail.setValue(this.model.userRoles.user.email);
    }
    this.model.setRequestAttributes(
      this.form_group,
      this.isAddUser ? RequestType.createUserRoles : RequestType.updateUserRoles
    );
  }

  /**
   * @function resetUserRoleObjects resets checkboxes and the form_group
   */
  resetUserRoleObjects() {
    this.UserRoleObjects.forEach(
      (tab, index) => {
        tab.selected = false;
        tab.expanded = false;
        this.setTabCheckboxes(index);
      }
    );
    if (!this.isAddUser) {
      this.userRoles.roles.forEach(
        (role) => {
          this.form_group.value.roles.forEach(val => {
            if (role.roleName === val.roleName) { val.allowed = true; }
          });
        }
      );
    }
  }
  /**
   * @function resetUserType resets user type selections
   */
  resetUserTypes() {
      this.UserTypes.forEach(
        (type) => {
          type.selected = false;
        });
    }
  /**
   * clear clear after api call
   **/
  public clear(): void {
    this.apiDispatcher.setUserRoleUpdate({});
    this.sidenav.close();
  }

  /**
   * cancel cancel form
   **/
  public cancel(): void {
    this.showForm = false;
    this.showDeleteBtn = false;
    this.resetUserRoleObjects();
    this.resetUserTypes();
    this.sidenav.close();
  }

  /**
   * @function showDeleteUserDialog Method to show dialog before deleting the user
   */
  public showDeleteUserDialog() {
    this.dialog.open(DialogBoxComponent, {
      data: {
        type: 'delete-user',
        userEmail: this.model.userRoles.user.email,
        message: `${this.translate.getCustomTranslation('user-roles.labels.want-to-delete')['value']}'${this.model.userRoles.user.email
          }' ?`,
      },
      width: '34em',
      height: 'auto',
    });
  }

  /**
   * deleteSelectedUser opens the Dialog box and upon confirm deletes the selected user
   **/
  public deleteSelectedUser(): void {
    this.showDeleteUserDialog();
  }
}
